import { gql } from '@apollo/client'
import { ID } from '../IQueryData'

export enum AccessCardType {
  prox40 = 'prox40',
  prox816 = 'prox816',
  seos = 'seos',
}

export interface ITenantSeos {
  disabled?: boolean
  id: ID
  prefix: string
}

export interface IParkingPoolUser {
  login: string
  firstName: string
  lastName: string
  disabled: boolean
  email: { email: string } | null
  workEmail: { email: string } | null
  accessCard: {
    number: string
    type: AccessCardType
  }
  parkingPoolData: {
    id: string
    carPlate?: string
    carPlate2?: string
    enabled?: boolean
    isValid?: boolean
  }
  parkingPoolProfile: {
    id: string
    name: string
  }
}

export interface ITenantUsers {
  id: string
  name: string
  seos?: ITenantSeos
  employees: IParkingPoolUser[]
}

export interface IQueryUsersVars {
  tenant: string
}

export interface IQueryUsersData {
  getTenant: ITenantUsers | null
}

export const QUERY_USERS_LIST = gql`
  query queryUsersList($tenant: String!) {
    getTenant(name: $tenant) {
      name
      id
      seos {
        disabled
        id
        prefix
      }
      employees(filter: { not: { disabled: true } })
        @cascade(fields: ["tenant"]) {
        login
        firstName: first_name
        lastName: last_name
        disabled
        email {
          email
        }
        workEmail: work_email {
          email
        }
        tenant(filter: { name: { eq: $tenant } }) {
          name
          id
        }
        accessCard: access_card {
          number
          type
        }
        parkingPoolData: parking_pool_data {
          id
          carPlate: car_plate
          carPlate2: car_plate_2
          enabled
          isValid: is_valid
        }
        parkingPoolProfile: parking_pool_profile {
          id
          name
        }
      }
    }
  }
`
